<template>
	<div>
		<Landing v-if="showLanding" @skipCompents="landingClcik" @refreshSkip="landRefSkip"></Landing>
		<div class="head-guidance">
			<div class="left-row jusfy-end align-center">
				<div class="head-guidance-flex-socor">
					<div @click="imageGroup" class="image-group">
						<img src="../assets/about_slices/Group 1886@2x.png" class="image" />
					</div>
					<div class="head-right">
						<div class="head-right-flex" :class="{ 'head-right-flex1Sraint': props.idShwo == 1 }" @click="skipClick('/')">
							<img src="../assets/Home_slices1/Vector@2x(1).png" v-if="props.idShwo == 1" style="width: 16px; height: 14px" />
							<img src="../assets/Frame 1_slices/Vector@2x(3).png" v-else style="width: 16px; height: 14px" />
							<div class="home-right">首页</div>
						</div>
						<div class="head-right-flex" :class="{ 'head-right-flex1Sraint': props.idShwo == 2 }" @click="skipClick('/cardVoucher')">
							<img src="../assets/Home_slices1/18@2x.png" v-if="props.idShwo != 2" style="width: 22px; height: 19px" />
							<img src="@/assets/Frame 1_slices/18@2x(1).png" v-else style="width: 22px; height: 19px" />
							<div class="home-right">卡券回收</div>
						</div>
						<div class="head-right-flex" :class="{ 'head-right-flex1Sraint': props.idShwo == 3 }" @click="skipClick('/dynamics')">
							<img src="@/assets/Frame 1_slices/Union@2x.png" v-if="props.idShwo != 3" style="width: 22px; height: 19px" />
							<img src="@/assets/Frame 1_slices/Group 1225@2x.png" v-else style="width: 22px; height: 19px" />
							<div class="home-right">公告动态</div>
						</div>
						<div class="head-right-flex" :class="{ 'head-right-flex1Sraint': props.idShwo == 4 }" @click="skipClick('/cooperation')">
							<img src="@/assets/Frame 1_slices/Group 1224@2x.png" v-if="props.idShwo == 4" style="width: 22px; height: 19px" />
							<img src="../assets/Frame 1_slices/Vector@2x.png" v-else style="width: 22px; height: 19px" />
							<div class="home-right">API合作</div>
						</div>
						<div class="head-right-flex" :class="{ 'head-right-flex1Sraint': props.idShwo == 7 }" @click="skipClick('/news')">
							<el-icon v-if="props.idShwo == 7" size="18" color="#fff"><Reading /></el-icon>
							<el-icon v-else size="18" color="#000"><Reading /></el-icon>
							<div class="home-right">卡券新闻</div>
						</div>
						
						<div class="head-right-flex" :class="{ 'head-right-flex1Sraint': props.idShwo == 6 }" @click="skipClick('/aboutUs')">
							<el-icon v-if="props.idShwo == 6" size="18" color="#fff"><Warning /></el-icon>
							<el-icon v-else size="18" color="#000"><Warning /></el-icon>
							<div class="home-right">关于我们</div>
						</div>
						
						<div class="head-right-flex" :class="{ 'head-right-flex1Sraint': props.idShwo == 5 }" @click="skipClick('/official')">
							<img src="@/assets/HomeView/Slice 152.png" v-if="props.idShwo == 5" style="width: 22px; height: 19px" />
							<img src="../assets/HomeView/Slice 15.png" v-else style="width: 22px; height: 19px" />
							<div class="home-right">关注公众号</div>
						</div>
					</div>
				</div>

				<div class="left-row" v-if="!information">
					<div class="left-row row-wdith align-center prainto" @click="searchClick">
						<img src="../assets/login-account/varsou.png" style="width: 15px; height: 15px" />
						<div class="row-title">搜索</div>
					</div>
					<div class="left-row row-gj align-center prainto" @click="skipClick('/login')">
						<img src="../assets/login-account/long.png" style="width: 20px; height: 20px" />
						<div class="row-gj-title">登录/注册</div>
					</div>
				</div>

				<div class="left-row row-wdith align-center prainto" v-if="information" @click="searchClick">
					<img src="../assets/login-account/varsou.png" style="width: 15px; height: 15px" />
					<div class="row-title">搜索</div>
				</div>
				<div class="head-right-flex" style="margin-right: 40px" v-if="information" @click="infoClick">
					<div>
						<img :src="information?.avatar" v-if="information.avatar" />
						<img v-else src="@/assets/default-header.png" style="width: 36px; height: 36px; border-radius: 100px" />
					</div>
					<div class="userName">{{ information?.nickname }}</div>
					<div class="userName">ID:{{ information?.id }}</div>
					<div class="arrowDown">
						<el-icon :size="10"><ArrowDown /></el-icon>
					</div>
				</div>
			</div>
			<div class="rows-sedpace" @click="showSearch = false" v-if="showSearch"></div>
			<div class="row-account-long" v-if="showSearch">
				<div class="row-padd">
					<el-input @change="changeEnent" v-model="modelName" style="width: 367px" placeholder="请输入需要回收卡劵名称">
						<template #suffix>
							<div @click="changeEnent">
								<el-icon><Search /></el-icon>
							</div>
						</template>
					</el-input>
					<div class="row-title-userName">热门回收卡劵</div>
					<div class="bak-row-userName">
						<div class="bak-row-bj" @click="Jump(item)" v-for="(item, index) in listData" :key="index">{{ item.title }}</div>
					</div>
				</div>
			</div>

			<div class="center" v-if="showInfo">
				<div class="triangular"></div>
				<div class="title-tranglar" @click="skipClick('/personalCenter')">个人中心</div>
				<div class="bor-top"></div>
				<div class="title-tranglar" @click="mesagesClick" style="display: flex; position: relative; justify-content: center">
					<div>消息通知</div>
					<div class="notification" v-if="number">{{ number }}</div>
				</div>
				<div class="bor-top"></div>
				<div class="title-tranglar" @click="logOut">退出登录</div>
			</div>
			<div class="person-trangler" v-if="showInfo" @click="infoClick"></div>
		</div>
		<div class="bjMy1sark" v-if="mesageShow">
			<div class="message1" style="height: 679px; width: 825px">
				<div class="mess-img" @click="layoutClick">
					<img src="@/assets/Group 1271@2x.png" style="height: 35px; width: 35px" />
				</div>
				<div>
					<div class="message-title">消息通知</div>
				</div>
				<div class="message-border"></div>
				<div v-if="listDate.length">
					<div style="height: 540px; overflow: hidden; overflow-x: auto; overflow-y: auto">
						<div class="slicess" v-for="(item, index) in listDate" :key="index" @click="sliceClick(item)">
							<div class="slicess-padd">
								<div class="title-sliceSQty" :class="{ 'title-sliceS1': item.readStatus == 1 }">{{ item.content }}</div>
								<div class="title-time11" :class="{ 'title-timeS1': item.readStatus == 1 }">{{ item.createTime }}</div>
							</div>
							<div class="message-border" style="margin-top: 16px"></div>
						</div>
					</div>

					<div class="pagination-contact1">
						<el-pagination background layout="total, prev, pager, next,jumper" @current-change="handleCurrentChange" :total="total" />
					</div>
				</div>
				<div v-else>
					<el-empty description="数据为空" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Landing from '@/components/landing.vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { cardMessage, cardMessageUnread, messageRead } from '@/utils/api.js';
import { Search } from '@element-plus/icons-vue';

import dayjs from 'dayjs';
let router = useRouter();
let emit = defineEmits(['refreshTheStatus', 'clickEmit']);
let showLanding = ref(false);
let information = ref({});
let showInfo = ref(false);
let mesageShow = ref(false);
let listDate = ref([]);
let pageNo = ref(1);
let total = ref(0);
let messageCount = ref(0);
let number = ref(0);
let modelName = ref('');
let showSearch = ref(false);
let props = defineProps(['idShwo', 'flexKey']);

let listData = ref([{ title: '联通' }, { title: '京东E卡' }, { title: '电信' }, { title: '沃尔玛' }, { title: '携程任我行' }, { title: '天猫超市' }, { title: '中石化' }]);

const skipClick = (item) => {
	if (item == '/cardVoucher') {
		if (!information.value) {
			// showLanding.value = true;
			router.push({
				path: '/login'
			});
			return false;
		}
	}
	router.push({ path: item });
};
const skipclickTrue = () => {
	showLanding.value = true;
};
const landingClcik = () => {
	showLanding.value = !showLanding.value;
};
const landRefSkip = () => {
	let infomation = localStorage.getItem('information');
	information.value = JSON.parse(infomation);
	showLanding.value = false;
	emit('refreshTheStatus');
};
const infoClick = () => {
	showSearch.value = false;
	showInfo.value = !showInfo.value;
};
const layoutClick = () => {
	mesageShow.value = !mesageShow.value;
};
const mesagesClick = () => {
	mesageShow.value = !mesageShow.value;
	showInfo.value = false;
};
const logOut = () => {
	ElMessage({
		message: '已退出登录',
		type: 'success'
	});
	localStorage.removeItem('londEssage');
	localStorage.removeItem('information');
	showInfo.value = false;
	landRefSkip();
	router.push({ path: '/' });
};
const imageGroup = () => {
	router.push({ path: '/' });
};
const info = async () => {
	let ref = await cardMessage({
		pageNo: pageNo.value,
		pageSize: 10
	});
	listDate.value = ref.data?.list;
	if (!ref.data) {
		return false;
	}
	listDate.value.forEach((item, index) => {
		item.createTime = dayjs(item.createTime).format('YYYY年MM月DD日');
	});
	total.value = ref.data.total;
};
const handleCurrentChange = (item) => {
	pageNo.value = item;
	info();
};
const tostClick = async () => {
	let res = await cardMessageUnread();
	number.value = res.data;
};
const sliceClick = async (item) => {
	let res = await messageRead({ id: item.id });
	item.readStatus = 1;
	tostClick();
};
const searchClick = () => {
	showInfo.value = false;
	showSearch.value = !showSearch.value;
};
const changeEnent = () => {
	if (props.flexKey != 1) {
		router.push({ path: '/searchPage', query: { key: modelName.value } });
	} else {
		emit('clickEmit', modelName.value);
	}
};
const Jump = (item) => {
	if (props.flexKey != 1) {
		router.push({ path: '/searchPage', query: { key: item.title } });
	} else {
		emit('clickEmit', item.title);
	}
};
onMounted(() => {
	landRefSkip();
	info();
	tostClick();
});
defineExpose({
	skipclickTrue
});
</script>

<style lang="scss" scoped>
.rows-sedpace {
	position: fixed;
	z-index: -1;
	background-color: transparent;
	width: 100%;
	height: 100%;
}
.row-account-long {
	position: relative;
	z-index: 11;
	background-color: #fff;
	border-radius: 0px 0px 0px 0px;
	margin-left: auto;
	margin-right: 250px;
	margin-top: 10px;
	z-index: 11;
	width: 400px;
	border-radius: 5px;
	border: 1px solid #eeeeee;
	box-shadow: 10px 10px 20px 5px rgba(0, 0, 0, 0.1);
}

.row-title-userName {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 18px;
	font-style: normal;
	text-transform: none;
	margin-top: 10px;
	margin-left: 2px;
}

.bak-row-userName {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-left: -10px;
}

.bak-row-bj {
	background-color: #f2f2f2;
	padding: 5px 10px;
	margin-top: 10px;
	margin-left: 10px;
	border-radius: 15px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: rgba(34, 34, 34, 0.7);
	text-align: left;
	font-style: normal;
	text-transform: none;
}

.bak-row-bj:hover {
	cursor: pointer;
}

.row-padd {
	padding: 12px;
}

.head-guidance {
	width: 100%;
	height: 70px;
	background: #ffffff;
	border-radius: 0px 0px 0px 0px;
	position: fixed;
	top: 0;
	z-index: 111;
	border: 1px solid #eeeeee;
	.head-guidance-flex-socor {
		width: 86%;
		display: flex;
		// justify-content: center;
		.image {
			width: 141px;
			height: 33px;
			margin-top: 15px;
			margin-left: 24px;
		}
	}
	.head-right {
		display: flex;
		margin-right: 104px;
		align-items: center;

		.head-right-flex {
			display: flex;
			height: 10px;
			align-items: center;
			padding: 11px 16px;
			margin-top: 12px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
				white-space: nowrap;
			}
		}

		.head-right-flex:hover {
			cursor: pointer;
		}

		.head-right-flex1Sraint:hover {
			cursor: pointer;
		}

		.head-right-flex1Sraint {
			display: flex;
			align-items: center;
			background: #ff3333;
			border-radius: 74px 74px 74px 74px;
			margin-top: 13px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #fff;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
				white-space: nowrap;
			}
		}
		.frame-flex {
			height: 18px;
			border-right: 1px solid #dddddd;
			margin-top: 26px;
			margin-left: 22px;
			padding-right: 44px;
		}
	}
}

.userName {
	width: 65px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	line-height: 16px;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-left: 7px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.arrowDown {
	width: 12px;
	height: 12px;
	background: #eeeeee;
	border-radius: 40px;
	border: 1px solid #eeeeee;
	line-height: 12px;
	text-align: center;
}

.center {
	position: relative;
	width: 116px;
	height: 137px;
	background: rgba(51, 51, 51, 0.9);
	border-radius: 0px 0px 0px 0px;
	margin-left: auto;
	margin-right: 100px;
	margin-top: 25px;
	z-index: 11;
}
.center:hover {
	cursor: pointer;
}
.triangular {
	width: 0;
	height: 0;
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-bottom: 10px solid rgba(51, 51, 51, 0.9);
	position: absolute;
	top: -10px;
	right: 10px;
	white-space: nowrap;
}
.bor-top {
	width: 96px;
	height: 0px;
	border: 1px solid #5e5555;
	margin-left: 10px;
}
.title-tranglar {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	text-align: center;
	font-style: normal;
	text-transform: none;
	padding: 12px 0px;
}
.notification {
	padding: 1px 5px;
	background: #fc3030;
	border-radius: 10px 10px 10px 10px;
	color: #fff;
	margin-left: 4px;
	position: absolute;
	right: 8px;
}

.person-trangler {
	background-color: transparent;
	position: fixed;
	z-index: 1;
	width: 100%;
	height: 100%;
	top: 70px;
}

.bjMy1sark {
	position: fixed;
	width: 100%;
	height: calc(100% - 70px);
	background: rgba(0, 0, 0, 0.7);
	z-index: 1000;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.message1sark {
	width: 39%;
	height: 589px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	position: relative;
}

.mess-img {
	position: absolute;
	right: -15px;
	top: -15px;
}

.message-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 21px;
}
.message-border {
	width: 100%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 11px;
}

.slicess {
	padding: 0px 40px;
}
.slicess-padd {
	margin-top: 22px;
}

.slicess-padd:hover {
	cursor: pointer;
}

.pagination-contact1 {
	position: absolute;
	bottom: 30px;
	left: 50px;
}
.title-sliceSQty {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	font-style: normal;
	text-transform: none;
}
.title-time11 {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	font-style: normal;
	text-transform: none;
	margin-top: 7px;
}

.title-sliceS1 {
	color: #aaa;
}
.title-timeS1 {
	color: #aaa;
}
.image-group:hover {
	cursor: pointer;
}

.head-right-flex {
	display: flex;
	align-items: center;
	margin-top: 12px;
	margin-left: 16px;
}

.head-right-flex:hover {
	cursor: pointer;
}

.home-right {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-left: 6px;
	white-space: nowrap;
}

.left-row {
	display: flex;
}

.jusfy-end {
	justify-content: space-between;
}

.align-center {
	align-items: center;
}

.row-wdith {
	width: 70px;
	margin-top: 14px;
}
.row-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #222222;
	margin-left: 4px;
	font-style: normal;
	text-transform: none;
}
.row-gj {
	margin-right: 25px;
	margin-top: 14px;
	width: 114px;
	height: 34px;
	background: #ff2f17;
	border-radius: 8px 8px 8px 8px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.row-gj-title {
	margin-left: 6px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	font-style: normal;
	text-transform: none;
}

.prainto:hover {
	cursor: pointer;
}

.row-wdith:hover {
	cursor: pointer;
}
.row-gj:hover {
	cursor: pointer;
}
</style>
